import {BANK_TYPES} from '../../constants/typesMessages';

import {messageBankAccount} from './auxiliaryMessage';
import {
  clearNumbers,
  validateBankAccount,
  validateBankBranch
} from './validationBankDetails';

const bankNameCheck = (bankName, banksList, bankEcObject) => {
  const bank = banksList.filter(
    (bankItem) => bankItem.code === bankEcObject.code
  );

  if (bank.length) return bank[0];

  return {name: '', code: ''};
};

const setBankName = (bankName, bankEcObject, banksList) => {
  const bank = bankNameCheck(bankName, banksList, bankEcObject);

  bankEcObject.name = bank.name;
  bankEcObject.code = bank.code;
  bankEcObject.branch = '';
  bankEcObject.account = '';

  return {
    messages: [
      {
        text: bankName,
        edit: BANK_TYPES.BANK_NAME,
        type: BANK_TYPES.BANK_FLOW
      },
      {
        text: 'Combinado! Qual o número da agência do seu banco?',
        type: 'message-receive'
      }
    ],
    bank: bankEcObject,
    responseFlowChange: BANK_TYPES.BANK_BRANCH,
    responseTypeChange: BANK_TYPES.BANK_FLOW,
    completed: false
  };
};

const setBankBranch = (bankBranch, bankEcObject) => {
  const branch = clearNumbers(bankBranch);
  const validationResult = validateBankBranch(branch, bankBranch, bankEcObject);
  if (validationResult.error) {
    return validationResult;
  }

  bankEcObject.branch = branch;
  return messageBankAccount(bankBranch, bankEcObject);
};

const setBankAccount = (bankAccount, bankEcObject) => {
  const account = clearNumbers(bankAccount);
  const validationResult = validateBankAccount(
    account,
    bankAccount,
    bankEcObject
  );

  if (validationResult.error) return validationResult;

  bankEcObject.account = account;
  bankEcObject.accountType = 'CURRENT_ACCOUNT';
  delete bankEcObject.mask;

  return {
    messages: [
      {
        text: bankAccount,
        type: BANK_TYPES.BANK_FLOW
      },
      {
        text: '',
        type: BANK_TYPES.BANK_ACC_TYPE
      }
    ],
    bank: bankEcObject,
    responseFlowChange: '',
    responseTypeChange: 'disabled',
    completed: true
  };
};

const setBankAccountType = (bankAccountType, bankEcObject) => {
  bankEcObject = {
    ...bankEcObject,
    accountType: bankEcObject.accountType.bankAccountType
  };

  delete bankEcObject.mask;
  return {
    messages: [
      {
        text: bankAccountType,
        edit: BANK_TYPES.BANK_ACC_TYPE,
        type: BANK_TYPES.BANK_FLOW
      }
    ],
    bank: bankEcObject,
    responseFlowChange: '',
    responseTypeChange: 'disabled',
    completed: true
  };
};

export const typeDataUpdate = (
  dataType,
  bankDataMessage,
  bankEcObject,
  banksList
) => {
  switch (dataType) {
    case BANK_TYPES.BANK_NAME:
      return setBankName(bankDataMessage, bankEcObject, banksList);

    case BANK_TYPES.BANK_BRANCH:
      return setBankBranch(bankDataMessage, bankEcObject);

    case BANK_TYPES.BANK_ACC:
      return setBankAccount(bankDataMessage, bankEcObject);

    case BANK_TYPES.BANK_ACC_TYPE:
      return setBankAccountType(bankDataMessage, bankEcObject);

    default:
      return;
  }
};

/**
 * Converts API mask format to IMask-compatible format
 * Generates asterisk masks for bank account inputs based on API mask length
 *
 * @param {Object} bankSelected - Selected bank object from API
 * @param {string} bankSelected.mask - Mask pattern from API (e.g., '99999-9')
 * @returns {string} Asterisk mask for IMaskInput (e.g., '*******')
 *
 * @example
 * convertApiMaskToIMask({ mask: '99999-9' }) // Returns '*******'
 * convertApiMaskToIMask(null) // Returns '***************' (default)
 */
export const convertApiMaskToIMask = (bankSelected) => {
  const defaultMask = '***************';

  if (!bankSelected?.mask || bankSelected.mask.length === 0) {
    return defaultMask;
  }

  // Returns mask with asterisks (original react-text-mask behavior)
  return '*'.repeat(bankSelected.mask.length);
};

export const selectBankIntoList = (bankObject, banksList) => {
  const bankSelected = banksList.filter((bank) => {
    return bank.code === bankObject.code;
  });

  return bankSelected.length ? bankSelected[0] : [];
};
